
import { defineComponent, inject } from "vue";
import { AdmCard, AdmTypography, AdmButton } from "@/components";
import { API_CLIENT_KEY } from "@/service/api";

export default defineComponent({
  name: "SuccessStep",
  components: {
    AdmTypography,
    AdmCard,
    AdmButton,
  },
  setup() {
    const apiClient = inject(API_CLIENT_KEY);
    const { config } =
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      apiClient!;

    return {
      ebook: config.ebook,
    };
  },
});
